import {
  Reg28ActualAssetClassExposureMaxLimitsResponseModelMock,
  Reg28ActualAssetClassExposureResponseModelMock,
  Reg28ActualAssetClassExposureWeightsResponseModelMock
} from '../../../../types/regulation-28/regulation-28.interfaces';
import { ExposureTable } from '../../../../../../components/organisms/exposure-table/ExposureTable';

type ActualAssetClassExposureTableProps = {
  tableData: Reg28ActualAssetClassExposureResponseModelMock[];
  maxLimits?: Reg28ActualAssetClassExposureMaxLimitsResponseModelMock;
  weights?: Reg28ActualAssetClassExposureWeightsResponseModelMock;
};

export const Reg28ActualAssetClassExposureTable = ({
  tableData,
  maxLimits,
  weights
}: ActualAssetClassExposureTableProps) => {
  return (
    <ExposureTable
      columns={[
        {
          displayValue: 'Collective investment funds',
          align: 'left'
        },
        {
          displayValue: '%',
          align: 'right',
          maximumPercentage: maxLimits?.percentage,
          weightedPercentage: weights?.percentage
        },
        {
          displayValue: 'Equity %',
          align: 'right',
          maximumPercentage: maxLimits?.equity,
          weightedPercentage: weights?.equity
        },
        {
          displayValue: 'Property %',
          align: 'right',
          maximumPercentage: maxLimits?.property,
          weightedPercentage: weights?.property
        },
        {
          displayValue: 'Bonds %',
          align: 'right',
          maximumPercentage: maxLimits?.bonds,
          weightedPercentage: weights?.bonds
        },
        {
          displayValue: 'Cash %',
          align: 'right',
          maximumPercentage: maxLimits?.cash,
          weightedPercentage: weights?.cash
        },
        {
          displayValue: 'Hedge %',
          align: 'right',
          maximumPercentage: maxLimits?.hedge,
          weightedPercentage: weights?.hedge
        },
        {
          displayValue: 'Private equity %',
          align: 'right',
          maximumPercentage: maxLimits?.privateEquity,
          weightedPercentage: weights?.privateEquity
        },
        {
          displayValue: 'Commodities %',
          align: 'right',
          maximumPercentage: maxLimits?.commodities,
          weightedPercentage: weights?.commodities
        },
        {
          displayValue: 'Other %',
          align: 'right',
          maximumPercentage: maxLimits?.other,
          weightedPercentage: weights?.other
        }
      ]}
      rows={tableData.map((data) => ({
        values: [
          {
            rawValue: data.fundName,
            displayValue: data.fundName,
            align: 'left'
          },
          {
            rawValue: data.percentage ?? 0,
            displayValue: data.percentage?.toFixed(2) ?? '-',
            align: 'right'
          },
          {
            rawValue: data.equity ?? 0,
            displayValue: data.equity?.toFixed(2) ?? '-',
            align: 'right'
          },
          {
            rawValue: data.property ?? 0,
            displayValue: data.property?.toFixed(2) ?? '-',
            align: 'right'
          },
          {
            rawValue: data.bonds ?? 0,
            displayValue: data.bonds?.toFixed(2) ?? '-',
            align: 'right'
          },
          {
            rawValue: data.cash ?? 0,
            displayValue: data.cash?.toFixed(2) ?? '-',
            align: 'right'
          },
          {
            rawValue: data.hedge ?? 0,
            displayValue: data.hedge?.toFixed(2) ?? '-',
            align: 'right'
          },
          {
            rawValue: data.privateEquity ?? 0,
            displayValue: data.privateEquity?.toFixed(2) ?? '-',
            align: 'right'
          },
          {
            rawValue: data.commodities ?? 0,
            displayValue: data.commodities?.toFixed(2) ?? '-',
            align: 'right'
          },
          {
            rawValue: data.other ?? 0,
            displayValue: data.other?.toFixed(2) ?? '-',
            align: 'right'
          }
        ]
      }))}
    />
  );
};
